"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="128938" id="hero-service-overview" className="relative min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-background text-foreground overflow-hidden">
      <h1 className="sr-only">The Back Pain Blueprint: Chiropractic Care in Limassol & Nicosia</h1>
      <div ref={imgRef} className="relative h-[50vh] lg:h-full overflow-hidden rounded-none">
        <img alt="Warm clinical consultation environment with healthcare professionals" className="absolute inset-0 object-cover transition-transform duration-[2000ms] ease-out scale-100 !opacity-[1] rounded-none !h-[880px] !w-[720px]" src="https://bodywerks.com.cy/wp-content/uploads/2026/09/great-now-same-information-but.png" />
      </div>

      {}
      <div className="hidden lg:block absolute top-0 bottom-0 left-1/2 w-px bg-accent z-10 -translate-x-1/2 opacity-30" />

      {}
      <div className="flex items-center justify-center p-8 sm:p-12 lg:p-16 xl:p-24 bg-background z-0">
        <div ref={textRef} className={`max-w-xl flex flex-col items-start transition-all duration-1000 ease-out delay-300 ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <span className="font-sans uppercase tracking-widest text-accent font-semibold text-sm mb-4 block">
            Expert Medical Excellence
          </span>
          
          <h1 className="font-serif font-bold text-5xl sm:text-6xl lg:text-[72px] leading-[1.1] text-primary mb-6">The Back Pain Blueprint</h1>
          
          <p className="font-sans font-light leading-relaxed text-foreground/80 text-lg mb-10">A Complete Guide to Understanding What's Really Wrong and What Actually Works.<br />You can order the book on <a href="https://www.amazon.com/BACK-PAIN-BLUEPRINT-Complete-Understanding-ebook/dp/B0H6G2VZ2F" target="_blank" rel="noopener noreferrer" data-link-type="url" data-link-href="https://www.amazon.com/BACK-PAIN-BLUEPRINT-Complete-Understanding-ebook/dp/B0H6G2VZ2F" data-link-target="_blank" className="underline cursor-pointer">Amazon </a>as an ebook, paperback or hardback.<br />Physical copies can also be purchased from both clinics for €20 and you will receive a €20 discount off your next consultation.</p>
          
          <Button asChild size="lg" className="rounded-lg shadow-xl shadow-primary/10 hover:shadow-accent/40 transition-all px-8 h-14 text-base bg-primary text-primary-foreground hover:bg-accent">
            <Link to="/ContactPage">Book Your Consultation</Link>
          </Button>
        </div>
      </div>
    </section>;
}